var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 0C16.7812 0 0 16.7812 0 37.5C0 54.0937 10.7344 68.1094 25.6406 73.0781C27.5156 73.4063 28.2187 72.2813 28.2187 71.2969C28.2187 70.4063 28.1719 67.4531 28.1719 64.3125C18.75 66.0469 16.3125 62.0156 15.5625 59.9062C15.1406 58.8281 13.3125 55.5 11.7188 54.6094C10.4062 53.9062 8.53125 52.1719 11.6719 52.125C14.625 52.0781 16.7344 54.8437 17.4375 55.9687C20.8125 61.6406 26.2031 60.0469 28.3594 59.0625C28.6875 56.625 29.6719 54.9844 30.75 54.0469C22.4062 53.1094 13.6875 49.875 13.6875 35.5312C13.6875 31.4531 15.1406 28.0781 17.5313 25.4531C17.1563 24.5156 15.8437 20.6719 17.9062 15.5156C17.9062 15.5156 21.0469 14.5313 28.2187 19.3594C31.2187 18.5156 34.4063 18.0937 37.5938 18.0937C40.7813 18.0937 43.9688 18.5156 46.9688 19.3594C54.1406 14.4844 57.2813 15.5156 57.2813 15.5156C59.3438 20.6719 58.0313 24.5156 57.6563 25.4531C60.0469 28.0781 61.5 31.4062 61.5 35.5312C61.5 49.9219 52.7344 53.1094 44.3906 54.0469C45.75 55.2187 46.9219 57.4688 46.9219 60.9844C46.9219 66 46.875 70.0313 46.875 71.2969C46.875 72.2813 47.5781 73.4531 49.4531 73.0781C64.2656 68.1094 75 54.0469 75 37.5C75 16.7812 58.2188 0 37.5 0Z",
    fill: "#1B1F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider9);
export default __webpack_public_path__ + "static/media/slider-9.3b1d3608edd600a238eb6630bd43fd8b.svg";
export { ForwardRef as ReactComponent };